import { ExpiryAlerts } from 'domain/notification';
import { RequestNotification } from 'proxy/request-notification';

const getExpiryAlerts = (): Promise<ExpiryAlerts> => RequestNotification.getExpiryAlerts();

export const NotificationApiActions = {
  getExpiryAlerts,
};
